/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Pipe, PipeTransform } from '@angular/core';

declare var panelClasses: any;

@Pipe({ name: 'panelClass' })
export class PanelClass implements PipeTransform {
    transform(className: string) {
        if(panelClasses.hasOwnProperty(className))
            return panelClasses[className];
        else
            return className;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/pipes/panel_class.ts